<template>
  <el-card style="width: 49%;">
    <div ref="statistics" style="height: 350px;"></div>
  </el-card>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    statisticsData: Object
  },
  data() {
    return {
      myCharts: null
    }
  },
  watch: {
    statisticsData: {
      handler(val) {
        this.setChart();
      },
      deep: true
    }
  },
  methods: {
    setChart() {
      if (!this.myCharts) {
        this.myCharts = this.$echarts.init(this.$refs.statistics);
      }
      let statisticsData = this.statisticsData;
      if (!statisticsData || Object.keys(statisticsData) == 0) {
        return;
      }

      let axisData = [];
      let seriesData = [];
      for (let key in statisticsData) {
        axisData.push(key);
        seriesData.push(statisticsData[key])
      }

      this.myCharts.setOption({
        title: {
          text: '地域统计',
          left: 'center'
        },
        tooltip: {},
        xAxis: {
          type: 'category',
          data: axisData
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: seriesData,
            type: 'bar',
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(180, 180, 180, 0.2)'
            }
          }
        ]
      })
    }
  }
})
</script>
